import React, { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import TrackingSearch from './components/TrackingSearch';
import TrackingResult from './components/TrackingResult';
import { initializeSampleData } from './utils/sampleData';

function App() {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [shipmentData, setShipmentData] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    initializeSampleData();
  }, []);

  const handleSearch = (number) => {
    setIsSearching(true);
    setTrackingNumber(number);

    setTimeout(() => {
      const storedData = localStorage.getItem(`shipment_${number}`);
      if (storedData) {
        setShipmentData(JSON.parse(storedData));
      } else {
        setShipmentData(null);
      }
      setIsSearching(false);
    }, 500);
  };

  const handleReset = () => {
    setTrackingNumber('');
    setShipmentData(null);
  };

  return (
    <div 
      className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100"
      data-component-path="client/src/App.jsx"
      data-component-line="1:1"
      data-component-id="client/src/App.jsx:1:1"
    >
      <Toaster position="top-right" />
      
      <div 
        className="container mx-auto px-4 py-8"
        data-component-path="client/src/App.jsx"
        data-component-line="2:3"
        data-component-id="client/src/App.jsx:2:3"
      >
        <header 
          className="text-center mb-12"
          data-component-path="client/src/App.jsx"
          data-component-line="3:5"
          data-component-id="client/src/App.jsx:3:5"
        >
          <h1 
            className="text-4xl md:text-5xl font-bold text-gray-800 mb-3"
            data-component-path="client/src/App.jsx"
            data-component-line="4:7"
            data-component-id="client/src/App.jsx:4:7"
          >
            Shipment Tracking
          </h1>
          <p 
            className="text-gray-600 text-lg"
            data-component-path="client/src/App.jsx"
            data-component-line="5:7"
            data-component-id="client/src/App.jsx:5:7"
          >
            Track your courier and packers & movers shipments across Pan India
          </p>
        </header>

        <main 
          className="max-w-4xl mx-auto"
          data-component-path="client/src/App.jsx"
          data-component-line="6:5"
          data-component-id="client/src/App.jsx:6:5"
        >
          <TrackingSearch 
            onSearch={handleSearch}
            isSearching={isSearching}
            onReset={handleReset}
            hasResult={!!shipmentData}
          />

          {shipmentData && (
            <TrackingResult 
              data={shipmentData}
              trackingNumber={trackingNumber}
            />
          )}

          {!shipmentData && trackingNumber && !isSearching && (
            <div 
              className="bg-white rounded-lg shadow-lg p-8 text-center mt-8"
              data-component-path="client/src/App.jsx"
              data-component-line="7:7"
              data-component-id="client/src/App.jsx:7:7"
            >
              <div 
                className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4"
                data-component-path="client/src/App.jsx"
                data-component-line="8:9"
                data-component-id="client/src/App.jsx:8:9"
              >
                <span 
                  className="text-4xl"
                  data-component-path="client/src/App.jsx"
                  data-component-line="9:11"
                  data-component-id="client/src/App.jsx:9:11"
                >
                  ❌
                </span>
              </div>
              <h3 
                className="text-2xl font-bold text-gray-800 mb-2"
                data-component-path="client/src/App.jsx"
                data-component-line="10:9"
                data-component-id="client/src/App.jsx:10:9"
              >
                Tracking Number Not Found
              </h3>
              <p 
                className="text-gray-600"
                data-component-path="client/src/App.jsx"
                data-component-line="11:9"
                data-component-id="client/src/App.jsx:11:9"
              >
                No shipment found with tracking number: <strong>{trackingNumber}</strong>
              </p>
              <p 
                className="text-sm text-gray-500 mt-4"
                data-component-path="client/src/App.jsx"
                data-component-line="12:9"
                data-component-id="client/src/App.jsx:12:9"
              >
                Please verify the tracking number and try again. Sample tracking numbers: 1, 2, 3, 4, 5
              </p>
            </div>
          )}
        </main>

        <footer 
          className="text-center mt-16 text-gray-500 text-sm"
          data-component-path="client/src/App.jsx"
          data-component-line="13:5"
          data-component-id="client/src/App.jsx:13:5"
        >
          <p data-component-path="client/src/App.jsx" data-component-line="14:7" data-component-id="client/src/App.jsx:14:7">
            © 2025 Shipment Tracking. All times displayed in Indian Standard Time (IST)
          </p>
        </footer>
      </div>
    </div>
  );
}

export default App;